export const assetCondition = [
  {
    asset_id: "1215001",
    location: "1",
    name: "Centrifugal Pump 1",
    category: "Pump",
    score: "25",
    rating: "Very Poor",
    recommendation: "Plan for replacement",
    comment: "Planning for replacement in progress",
    forecasted_replacement_at: "19 Oct 2023",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "14,560",
    saving: "26,840",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215002",
    location: "1",
    name: "Centrifugal Pump 2",
    category: "Pump",
    score: "62",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "28 Jun 2024",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "0",
    saving: "41,400",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215003",
    location: "1",
    name: "Centrifugal Pump 3",
    category: "Pump",
    score: "51",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "20 Apr 2024",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "0",
    saving: "41,400",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215004",
    location: "1",
    name: "Screw Pump 1",
    category: "Pump",
    score: "78",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "25 Oct 2025",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "0",
    saving: "45,600",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215005",
    location: "1",
    name: "Screw Pump 2",
    category: "Pump",
    score: "74",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "11 Nov 2023",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "0",
    saving: "45,600",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215006",
    location: "1",
    name: "Screw Pump 3",
    category: "Pump",
    score: "72",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "25 Oct 2025",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "0",
    saving: "45,600",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215007",
    location: "1",
    name: "Generator 1",
    category: "Generator",
    score: "80",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Dec 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215008",
    location: "1",
    name: "Generator 2",
    category: "Generator",
    score: "71",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Dec 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215009",
    location: "1",
    name: "Generator 3",
    category: "Generator",
    score: "68",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "10 Feb 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215010",
    location: "2",
    name: "Centrifugal Pump 1",
    category: "Pump",
    score: "66",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "1 Jul 2026",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "0",
    saving: "41,400",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215011",
    location: "2",
    name: "Centrifugal Pump 2",
    category: "Pump",
    score: "38",
    rating: "Poor",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "3 Mar 2024",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "0",
    saving: "41,400",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215012",
    location: "2",
    name: "Centrifugal Pump 3",
    category: "Pump",
    score: "90",
    rating: "Excellent",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "17 Dec 2027",
    maintenance_base_cost: "41,400",
    maintenance_forecast_cost: "0",
    saving: "41,400",
    maintenance_annual_cost: "34,500",
  },
  {
    asset_id: "1215013",
    location: "2",
    name: "Screw Pump 1",
    category: "Pump",
    score: "27",
    rating: "Very Poor",
    recommendation: "Plan for replacement",
    comment: "Planning for replacement in progress",
    forecasted_replacement_at: "20 Nov 2023",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "22,500",
    saving: "23,100",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215014",
    location: "2",
    name: "Screw Pump 2",
    category: "Pump",
    score: "57",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "21 Feb 2024",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "0",
    saving: "45,600",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215015",
    location: "2",
    name: "Screw Pump 3",
    category: "Pump",
    score: "68",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "30 Mar 2024",
    maintenance_base_cost: "45,600",
    maintenance_forecast_cost: "0",
    saving: "45,600",
    maintenance_annual_cost: "38,000",
  },
  {
    asset_id: "1215016",
    location: "2",
    name: "Generator 1",
    category: "Generator",
    score: "73",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "17 Mar 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215017",
    location: "2",
    name: "Generator 2",
    category: "Generator",
    score: "72",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "17 Mar 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215018",
    location: "2",
    name: "Generator 3",
    category: "Generator",
    score: "77",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "17 Mar 2026",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215019",
    location: "3",
    name: "Cooler Fan 1",
    category: "Fan",
    score: "90",
    rating: "Excellent",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "1 Feb 2029",
    maintenance_base_cost: "49,200",
    maintenance_forecast_cost: "0",
    saving: "49,200",
    maintenance_annual_cost: "41,000",
  },
  {
    asset_id: "1215020",
    location: "3",
    name: "Cooler Fan 2",
    category: "Fan",
    score: "34",
    rating: "Poor",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "15 Mar 2024",
    maintenance_base_cost: "49,200",
    maintenance_forecast_cost: "0",
    saving: "49,200",
    maintenance_annual_cost: "41,000",
  },
  {
    asset_id: "1215021",
    location: "3",
    name: "Cooler Fan 3",
    category: "Fan",
    score: "63",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "20 Dec 2024",
    maintenance_base_cost: "49,200",
    maintenance_forecast_cost: "0",
    saving: "49,200",
    maintenance_annual_cost: "41,000",
  },
  {
    asset_id: "1215022",
    location: "3",
    name: "Cooler Fan 4",
    category: "Fan",
    score: "29",
    rating: "Very Poor",
    recommendation: "Plan for replacement",
    comment: "Planning for replacement in progress",
    forecasted_replacement_at: "23 Jan 2024",
    maintenance_base_cost: "49,200",
    maintenance_forecast_cost: "35,600",
    saving: "13,600",
    maintenance_annual_cost: "41,000",
  },
  {
    asset_id: "1215023",
    location: "3",
    name: "Generator 1",
    category: "Generator",
    score: "71",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "21 Apr 2025",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215024",
    location: "3",
    name: "Generator 2",
    category: "Generator",
    score: "79",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "21 Apr 2025",
    maintenance_base_cost: "60,000",
    maintenance_forecast_cost: "0",
    saving: "60,000",
    maintenance_annual_cost: "50,000",
  },
  {
    asset_id: "1215025",
    location: "3",
    name: "Air Compressor 1",
    category: "Compressor",
    score: "83",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "23 Jun 2024",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215026",
    location: "3",
    name: "Air Compressor 2",
    category: "Compressor",
    score: "55",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "20 May 2024",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215027",
    location: "3",
    name: "Air Compressor 3",
    category: "Compressor",
    score: "59",
    rating: "Fair",
    recommendation: "Monitor closely",
    comment: "",
    forecasted_replacement_at: "20 May 2024",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215028",
    location: "3",
    name: "Air Compressor 4",
    category: "Compressor",
    score: "70",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Apr 2024",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215029",
    location: "3",
    name: "Air Compressor 5",
    category: "Compressor",
    score: "90",
    rating: "Excellent",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "28 Dec 2028",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215030",
    location: "4",
    name: "Cooling Tower 1",
    category: "Exchanger",
    score: "91",
    rating: "Excellent",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "1 Jul 2029",
    maintenance_base_cost: "66,000",
    maintenance_forecast_cost: "0",
    saving: "66,000",
    maintenance_annual_cost: "55,000",
  },
  {
    asset_id: "1215031",
    location: "4",
    name: "Cooling Tower 2",
    category: "Exchanger",
    score: "90",
    rating: "Excellent",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "1 Jul 2029",
    maintenance_base_cost: "66,000",
    maintenance_forecast_cost: "0",
    saving: "66,000",
    maintenance_annual_cost: "55,000",
  },
  {
    asset_id: "1215032",
    location: "4",
    name: "Cooling Tower 3",
    category: "Exchanger",
    score: "88",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "20 Feb 2024",
    maintenance_base_cost: "66,000",
    maintenance_forecast_cost: "0",
    saving: "66,000",
    maintenance_annual_cost: "55,000",
  },
  {
    asset_id: "1215033",
    location: "4",
    name: "Air Compressor 1",
    category: "Compressor",
    score: "78",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Jun 2025",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215034",
    location: "4",
    name: "Air Compressor 2",
    category: "Compressor",
    score: "79",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Jun 2025",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
  {
    asset_id: "1215035",
    location: "4",
    name: "Air Compressor 3",
    category: "Compressor",
    score: "75",
    rating: "Good",
    recommendation: "Operate machine within recommended parameters",
    comment: "",
    forecasted_replacement_at: "30 Jun 2025",
    maintenance_base_cost: "42,000",
    maintenance_forecast_cost: "0",
    saving: "42,000",
    maintenance_annual_cost: "35,000",
  },
];

export const assetCondition2 = [
  //ZONE 1

  {
    "Asset ID": "ASD-GSE-01CR01-PAC002",
    "Asset Name": "AIR COMPRESSOR",
    Level: "5",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    location: "1",
    Recommendation: "Do Nothing",
    maintenance: "$12,199",
    forecast: "$0",
    saving: "$12,199",
    "Score A": "12",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    "Asset Name": "AIR COMPRESSOR",
    Level: "5",
    maintenance: "$45,563",
    saving: "$45,563",
    forecast: "$0",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    Recommendation: "Do Nothing",
    location: "1",
    "Score A": "14",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
  {
    "Asset ID": "ASD-GSE-03CR02-PAC003",
    "Asset Name": "AIR COMPRESSOR",
    maintenance: "$1,760",
    saving: "$1,760",
    forecast: "$0",
    Level: "5",
    Group: "COMPRESSOR",
    "Machine Health": "Acceptable",
    Recommendation: "Do Nothing",
    location: "1",
    "Score A": "12",
    "Score B": "1",
    "Score C": "3",
    "Score D": "3",
  },
];
